import { FC } from 'react';
import { useNavigate } from 'react-router-dom';

import classNames from './dashboard.module.scss';

import * as auth from '../../../services/authService';
import * as models from '../../../utils/models';
import * as utils from '../../../utils/utilities';

interface DashboardRecentProjectProps {
	project: models.Project;
}

const DashboardRecentProject: FC<DashboardRecentProjectProps> = ({
	project,
}) => {
	const navigate = useNavigate();
	const user = auth.getCurrentUser() as models.User;

	const handleViewProject = () => {
		const path: string = `/dashboard/projects/${project._id}`;
		navigate(path);
	};

	const renderViewProject = () => {
		if (user.role.manageReports && project.supervisorId !== user.id)
			return null;

		return (
			<button
				className={classNames.recentProjectCTA}
				onClick={handleViewProject}
			>
				<span>View Project</span>
				<i className="bi bi-chevron-right"></i>
			</button>
		);
	};

	return (
		<div className={classNames.recentProject}>
			<div className={classNames.recentProjectIcon}>
				<i className="bi bi-kanban-fill"></i>
			</div>

			<div className={classNames.recentProjectDetails}>
				<div className={classNames.recentProjectTitle}>
					{project.documentNumber}
				</div>

				<p>{utils.summarize(project.projectTitle, 40)}</p>

				<div className={classNames.recentProjectTime}>
					{utils.getRelativeTime(project.createdAt)}
				</div>
			</div>

			{renderViewProject()}
		</div>
	);
};

export default DashboardRecentProject;
